import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import {InputTextModule, ButtonModule, PanelModule, DataGridModule, BlockUIModule, PasswordModule} from 'primeng/primeng';
import {DialogModule, MessagesModule, ProgressBarModule,GrowlModule} from 'primeng/primeng';

import { routing } from './app.routing';
import {Constants} from './shared/constants';
import { HttpService } from './shared/service/http.service';
import {LookupService} from './shared/service/lookupService';
import {AuthService} from './shared/service/auth.service';
import {ProgressService} from './shared/service/progress.service';
import { App } from './app.component';

import {Footer} from './footer/footer.component';
import {Header} from './header/header.component';
import {GlobalService} from "./shared/service/global.service";
import {AuthGuard} from "./shared/guards/auth.guard";
import {AmazonGuard} from "./shared/guards/amazon.guard";
import {AdminGuard} from "./shared/guards/admin.guard";
import {ErrorComponent} from "./error/error.component";
import {LoginComponent} from "./login/login.component";
import {ProfileComponent} from "./profile/profile.component";
import {ToastModule} from "primeng/toast";
import {MessageService} from "primeng/api";
import {MsgService} from "./shared/service/message.service";
import {SLBGuard} from "./shared/guards/slb.guard";
import {DellGuard} from "./shared/guards/dell.guard";
import {SEOGuard} from "./shared/guards/seo.guard";
import {ConfirmDialogModule} from "primeng/primeng";
import {FormsModule, ReactiveFormsModule, Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';
import {DemoGuard} from "./shared/guards/demo.guard";
import {FTNTGuard} from "./shared/guards/ftnt.guard";
import {TRDGuard} from './shared/guards/trd.guard';

const APP_PROVIDERS = [
  HttpService,
  AuthService,
  ProgressService,
  GlobalService,
  MessageService,
  MsgService,
  Constants,
  LookupService

];
const NG_MODULES = [
  InputTextModule,
  ButtonModule,
  PanelModule,
  MessagesModule,
  DataGridModule,
  DialogModule,
  ProgressBarModule,
  PasswordModule,
  GrowlModule,
  BlockUIModule,
  ToastModule,
  ConfirmDialogModule,
];

const GUARDS = [
  AuthGuard,
  AmazonGuard,
  AdminGuard,
  SLBGuard,
  DellGuard,
  DemoGuard,
  SEOGuard,
  FTNTGuard,
  TRDGuard
];

@NgModule({
  declarations: [
    App, LoginComponent, ProfileComponent, Footer, Header, ErrorComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    NG_MODULES],
  providers: [APP_PROVIDERS, GUARDS],
  bootstrap: [App]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/app.module.ts